<rask-page
    pageTitle="Marknadsprislistor"
    [actionShow]="true"
    [actionFn]="create"
    [actionDisabled]="!canEdit()"
    actionTitle="Lägg till marknadsprislista"
    noPadding>
    @if (marknadsomrade && handelssortimentGrupper) {
    <ng-container headerContent>
        <rask-marknadsprislista-search [marknadsomrade]="marknadsomrade"
            [handelssortimentGrupper]="handelssortimentGrupper"
            (marknadsprislistor)="onMarknadsprislistor($event)">
        </rask-marknadsprislista-search>
    </ng-container>
}
<rask-list [data]="marknadsprislistor">
    <rask-list-column header="Viol Id" field="violId" [sortable]="true">
    <ng-template let-row="row">
        <a href="#" (click)="edit($event, row)">{{row.violId}}</a>
    </ng-template>
    </rask-list-column>
    <rask-list-column header="Benämning" field="benamning" [sortable]="true">
    <ng-template let-row="row">
        <a href="#" (click)="edit($event, row)">{{row.benamning}}</a>
    </ng-template>
    </rask-list-column>
    <rask-list-column header="VLG" field="vidLeveransGallande" [sortable]="true"></rask-list-column>
    <rask-list-column header="RO" field="resultatsomraden" [sortable]="true"></rask-list-column>
    <rask-list-column header="HS-Grupp" field="handelssortimentsgrupper" [sortable]="true"></rask-list-column>
    <rask-list-column header="Gäller fr o m-t o m" field="galler" [sortable]="true"></rask-list-column>
    <rask-list-column header="Aktuell" field="aktuell" [sortable]="true"></rask-list-column>
    <rask-list-column header="Används för" field="typ" [sortable]="true"></rask-list-column>
</rask-list>
</rask-page>
